import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'

export function useLayoutStateToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [GraphQL.LayoutState.Archived]: t`Archived`,
      [GraphQL.LayoutState.Draft]: t`Draft`,
      [GraphQL.LayoutState.Published]: t`Published`
    }
  }, [t])
}
